export default function CsharpStringInterpolation() {
  return (
    <h2>Csharp String Interpolation</h2>
  );
}
